













import traceQuery from '~/queries/trace.gql'

export default

	props:
		traceData: Object

	computed:

		regions: ->
			countries = @traceData?.countries.map (country) ->
				if country.COOCountry == "United States" then return 'california'
				else return country.COOCountry.toLowerCase()

			uniqCountries = [...new Set countries]

			return uniqCountries


